export default "__VITE_ASSET__24f6fab1__"